import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero.js';
import Features from './pages/Features.js';
import Calculator from './pages/Calculator.js';
import Media from './pages/Media.js';       // New dedicated file
import Contact from './pages/Contact.js';   // New dedicated file
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Index path restricted strictly to your Hero capture layout */}
          <Route index element={<Hero />} />
          <Route path="/features" element={<Features />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;